<div>
  <app-header-bar class="header-bar"></app-header-bar>

  <app-tools-bar></app-tools-bar>

  <div id="map" class="drag-boundary"></div>

  <!-- Add panel after map to be over the leaflet overlay -->
  <app-panel></app-panel>
</div>
